import { Grid, Stack } from "@mui/system";
import VerticalLinearStepper from "../VerticalLinearStepper";
import { RecapCard } from "../../RecapCard";
import {
  Card,
  CardContent,
  Divider,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import { LiveCodeBlock } from "../../LiveCodeBlock";
import { motion } from "framer-motion";

export const KdappontLesson7 = () => {
  const subjectBlocks = [
    {
      label: "HTML Media",
      main: (
        <>
          <LiveCodeBlock
            code={`<video width="320" height="240" controls autoplay>
    <source src="/presentation-data/KDAPPONT2/lesson7/mov_bbb.mp4" type="video/mp4">
</video>`}
          />
          <Divider sx={{ my: 2 }} />
          <LiveCodeBlock
            code={`<audio controls>
    <source src="/presentation-data/KDAPPONT2/lesson7/sound.mp3" type="audio/mpeg">
</video>`}
          />
        </>
      ),
    },
    {
      label: "iFrame",
      main: (
        <>
          <LiveCodeBlock
            code={`<iframe 
    width="560" 
    height="315"
    src="https://www.youtube.com/embed/RXlM8sI18LI?si=9TlEB4JlMVQ_tEpn">
</iframe>

<iframe 
    width="560" 
    height="315"
    src="https://matse.ict-lab.nl/">
</iframe>`}
          />
        </>
      ),
    },
  ];

  return (
    <VerticalLinearStepper
      steps={[
        {
          label: " 🗓️ Planning",
          description: "",
          content: (
            <>
              <img
                src="/presentation-data/KDAPPONT2/lesson7/planning-l7.png"
                width="100%"
                alt=""
              />
            </>
          ),
        },
        {
          label: "👨🏼‍🏫 Voor vandaag | Les #7 | HTML Media",
          description: ``,
          content: (
            <Grid container columns={4} spacing={2}>
              {subjectBlocks.map((subject) => (
                <Grid size={2} sx={{ "& > *": { height: "100%" } }}>
                  <RecapCard subject={subject} />
                </Grid>
              ))}
            </Grid>
          ),
        },
        {
          label: "🖥️ Voorbereiden Toets",
          description: ``,
          content: <KdappontExamTraining />,
        },
      ]}
    />
  );
};

const keywords = [
  {
    key: "Valide HTML5",
  },
  {
    key: "Commentaar regels",
  },
  {
    key: "<title>",
  },
  {
    key: "<main>",
  },
  {
    key: "<h1> & <h2>",
  },
  {
    key: "<header>",
  },
  {
    key: "<nav>",
  },
  {
    key: "<ul> & <li>",
  },
  {
    key: "<footer>",
  },
  {
    key: "<article>",
  },
  {
    key: "<section>",
  },
  {
    key: "<aside>",
  },
  {
    key: "<address>",
  },
  {
    key: "<img>",
  },
  {
    key: "<a>",
  },
  {
    key: "<table> met <thead>, <tbody>, <tfoot>, <tr>, <th> en <td>",
  },
  {
    key: "<form> met <fieldset>, <legend>",
  },
  {
    key: "<label> met verschillende <input>'s, <select> en <textarea>",
  },
  {
    key: "<button>",
  },
  {
    key: "<video>",
  },
];

const AnimatedCard = motion(Card);

export const KdappontExamTraining = () => {
  return (
    <Stack gap={2}>
      <List sx={{ margin: 0 }}>
        <ListItem>
          <Typography variant="h5">
            🚫 Gebruik vandaag géén AI. W3Schools e.d. is uiteraard wel
            toegestaan.
          </Typography>
        </ListItem>

        <ListItem>
          <Typography variant="h5">
            👷 Bouw een volledig valide en logische HTML layout die gebruikt
            maakt van minstens de onderstaande "ingrediënten".
          </Typography>
        </ListItem>

        <ListItem>
          <Typography variant="h5">
            🔗 Link (&lt;a&gt;) minstens naar één andere lokale pagina.
          </Typography>
        </ListItem>
      </List>

      <Divider />

      <Grid container size={12} spacing={2}>
        {keywords.map((keyword, index) => (
          <Grid size={3} key={index}>
            <AnimatedCard
              animate={{
                backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
              }}
              transition={{
                duration: 8,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              sx={{
                textAlign: "center",
                background:
                  "linear-gradient(-45deg, #9dd385ff, #a8e063, #56ab2f)",
                backgroundSize: "200% 200%",
                color: "white",
                p: 1,
                borderRadius: 2,
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              <CardContent sx={{}}>
                <Typography
                  sx={{ textShadow: "2px 2px 1px rgba(0, 0, 0, 0.1)" }}
                  variant="h4"
                  component="div"
                  fontWeight="bold"
                  color="black"
                >
                  {keyword.key}
                </Typography>
              </CardContent>
            </AnimatedCard>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};
